import React from 'react'

export function Flex ({
  style,
  row, // row => riga, default a column
  children,
  js, // JustifyStart => justifyContent a flex-start
  jb, // JustifyBetween => justifyContent a space-between
  je, // JustifyEnd => justifyContent a flex-end
  jn, // JustifySpaceEvenly => justifyContent a space-evenly
  ac, // AlignCenter => alignItems center (default, consumed to avoid DOM warning)
  as, // AlignStart => alignItems a flex-start
  ae, // AlignEnd => alignItems a flex-end
  ab, // AlignSpaceEvenly
  an, // AlignBaseline
  width,
  height,
  fw, // FullWidth => width a 100%
  fh, // FullHeight => height a 100%
  bg, // BackgroundColor a red o al colore specificato
  wrap, // flexWrap a wrap
  pageW,
  ...props
}) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: row ? 'row' : 'column',
        justifyContent: 'center',
        alignItems: 'center',
        ...(js ? { justifyContent: 'flex-start' } : {}),
        ...(jb ? { justifyContent: 'space-between' } : {}),
        ...(je ? { justifyContent: 'flex-end' } : {}),
        ...(jn ? { justifyContent: 'space-evenly' } : {}),
        ...(as ? { alignItems: 'flex-start' } : {}),
        ...(ae ? { alignItems: 'flex-end' } : {}),
        ...(ab ? { alignItems: 'baseline' } : {}),
        ...(an ? { alignItems: 'space-evenly' } : {}),
        ...(fw ? { width: '100%' } : {}),
        ...(fh ? { height: '100%' } : {}),
        ...(width ? { width } : {}),
        ...(height ? { height } : {}),
        ...(bg ? { backgroundColor: bg === true ? 'red' : bg } : {}),
        ...(wrap ? { flexWrap: wrap === true ? 'wrap' : wrap } : {}),
        ...(pageW ? { width: pageW ? '80%' : '100%', margin: '0 auto' } : {}),
        ...style
      }}
      {...props}
    >
      {children}
    </div>
  )
}
